module.exports = __webpack_public_path__ + "img/add.6a61ec4f.png";